import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipDirective, TooltipModule } from 'ngx-bootstrap/tooltip';
import { BehaviorSubject } from 'rxjs';

const AUTO_CLOSE_DELAY_MS = 900;

@Component({
  selector: 'tmx-nav-dropdown',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './nav-dropdown.component.html',
  styleUrls: ['./nav-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavDropdownComponent {
  @Input() dropdownTooltip: TemplateRef<unknown> | string = '';
  @Input() ariaLabel = '';
  @Input() disabled = false;
  @Input() closeAutomatically = true;

  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  private timeoutId: unknown;
  private keepOpen = false;

  isOpen$ = new BehaviorSubject(false);

  @HostListener('document:click')
  clickOutside() {
    if (this.keepOpen) {
      this.keepOpen = false;
    } else {
      this.isOpen$.next(false);
    }
  }

  @HostListener('click')
  clickInside() {
    this.keepOpen = true;
  }

  toggleMenu() {
    const isOpen = !this.isOpen$.value;
    this.isOpen$.next(isOpen);
    if (isOpen) {
      this.opened.next();
    } else {
      this.closed.next();
    }
  }

  closeMenuAutomatically() {
    const isOpen = this.isOpen$.value;
    if (isOpen && this.closeAutomatically) {
      this.timeoutId = setTimeout(() => {
        this.isOpen$.next(false);
        this.closed.next();
      }, AUTO_CLOSE_DELAY_MS);
    }
  }

  cancelCloseMenuAutomatically() {
    clearTimeout(this.timeoutId as number);
  }

  toggle(tooltip: TooltipDirective) {
    tooltip.toggle();
  }
}
